/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnimalExternalNumber } from '../models/animal-external-number';
import { findAll16 } from '../fn/animal-external-number/find-all-16';
import { FindAll16$Params } from '../fn/animal-external-number/find-all-16';

@Injectable({ providedIn: 'root' })
export class AnimalExternalNumberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll16()` */
  static readonly FindAll16Path = '/api/values/animal-external-number';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll16()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll16$Response(params?: FindAll16$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnimalExternalNumber>>> {
    return findAll16(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll16$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll16(params?: FindAll16$Params, context?: HttpContext): Observable<Array<AnimalExternalNumber>> {
    return this.findAll16$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AnimalExternalNumber>>): Array<AnimalExternalNumber> => r.body)
    );
  }

}
